import {
  ProductPriceInfo,
  productPriceInfoFromResponse,
} from '../Product/ProductPriceInfo';
import { BasketProduct, basketProductFromResponse } from './BasketProduct';
import { BasketOption, basketOptionFromResponse } from './BasketOption';

export interface BasketItem {
  id: number;
  quantity: number;
  productID: number;
  price: ProductPriceInfo;
  total: ProductPriceInfo;
  hasOfferApplied: boolean;
  hasAtCheckoutDiscount: boolean;
  product: BasketProduct;
  options: BasketOption[];
}

export const basketItemFromResponse = (responseData: any): BasketItem => ({
  id: responseData.id,
  quantity: responseData.quantity,
  productID: responseData.product_id,
  price: productPriceInfoFromResponse(responseData.price),
  total: productPriceInfoFromResponse(responseData.total),
  hasOfferApplied: responseData.has_offer_applied,
  hasAtCheckoutDiscount: responseData.has_at_checkout_discount,
  product: basketProductFromResponse(responseData.product),
  options: (responseData.options ?? []).map(basketOptionFromResponse),
});
